import { Box } from "@mui/material"

const Spacer = () => {
    return (
        <Box m={2}></Box>
    )
}

export default Spacer